import Scrollable from "../../Shared/Edit/Scrollable";
import ComponentToolbar from "./ComponentToolbar/ComponentToolbar";
import componentPropertiesMap from './ComponentFormProperties.json';
import { useChangeBooleans, useComponentProperties, useResetComponentProperties, useSaveComponent } from "../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from "react";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useSelectedPage, useUpdatePageComponent } from "../../../Hooks/Display/usePages";
import ComponentFormSkeleton from "../../Display/Shared/ComponentFormSkeleton";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";
import { useTranslation } from "react-i18next";
import { DropDownList } from "@progress/kendo-react-dropdowns";

function SplitSection() {

    const splitSizes = ["1/3", "1/2", "2/3"];

    const formProperties = componentPropertiesMap.SplitSection;

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");
    const resetContext = useResetComponentProperties();
    const saveComponent = useSaveComponent();
    const updatePageComponent = useUpdatePageComponent(selectedComponent.parentId, selectedPage._id);

    const [properties, setProperty] = useComponentProperties();
    const [{ isGeneralPropertiesChanged }, setChangeProperty] = useChangeBooleans();

    const { t } = useTranslation("display/common", { useSuspense: false });

    useEffect(() => {
        setProperties();
        setLoading(false);
    }, [])

    // componentWillUnmount
    useEffect(() => {
        return () => {
            resetContext();
        }
    }, [])

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!loading) {
            setIsChanged();
        }
    }, [properties]);

    // state
    const [tabSelected, setTabSelected] = useState(0);

    // functions
    function setProperties() {
        for (const property of formProperties) {
            if (
                selectedComponent[property] !== undefined
            ) {
                setProperty(property, selectedComponent[property])
            }
            setChangeProperty("isGeneralPropertiesChanged", false);
        }
    }

    function handleChange(e) {
        const otherProperty = e.target.name === "firstSectionSize" ? "secondSectionSize" : "firstSectionSize";
        if (e.target.value === "1/3") {
            setProperty(otherProperty, "2/3");
        } else if (e.target.value === "2/3") {
            setProperty(otherProperty, "1/3");
        } else {
            setProperty(otherProperty, "1/2");
        }
        setProperty(e.target.name, e.target.value);
    }

    function setIsChanged() {
        let isChanged = false;
        for (const property of formProperties) {
            if (selectedComponent[property] !== properties[property]) {
                isChanged = true;
                break;
            }
        }
        setChangeProperty("isGeneralPropertiesChanged", isChanged);
    }

    // handlers
    function handleTabSelect(event) {
        setTabSelected(event.selected);
    }

    async function handleSave() {
        const updatedComponent = await saveComponent();
        updatePageComponent(selectedComponent.id, updatedComponent);
    }

    function resetComponent() {
        if (isGeneralPropertiesChanged) {
            setProperties();
        }
    }

    if (loading) {
        return <ComponentFormSkeleton />
    }

    return (
        <div className={"h-100 d-flex flex-column line" + (!accessedFromDesigner && " runtimePopup")}>
            <ComponentToolbar onSave={handleSave} onReset={resetComponent} />
            <Scrollable noPadding={true}>
                <TabStrip className="flex-grow-1 h-100 edit1" selected={tabSelected} onSelect={handleTabSelect}>
                    <TabStripTab title={t("tabs.general")}>
                        <Scrollable>
                            <form className="p-2 edit2">
                                <div className="form-label" required>
                                    First Section
                                </div>
                                <DropDownList
                                    name="firstSectionSize"
                                    data={splitSizes}
                                    value={properties.firstSectionSize}
                                    onChange={handleChange}
                                />
                                <div className="form-label" required>
                                    Second Section
                                </div>
                                <DropDownList
                                    name="secondSectionSize"
                                    data={splitSizes}
                                    value={properties.secondSectionSize}
                                    onChange={handleChange}
                                />
                            </form>
                        </Scrollable>
                    </TabStripTab>
                </TabStrip>
            </Scrollable>
        </div>
    )
}

export default SplitSection;